import { render, staticRenderFns } from "./WideCompetenceCenterData.vue?vue&type=template&id=57ab2bde&scoped=true&"
import script from "./WideCompetenceCenterData.vue?vue&type=script&lang=js&"
export * from "./WideCompetenceCenterData.vue?vue&type=script&lang=js&"
import style0 from "./WideCompetenceCenterData.vue?vue&type=style&index=0&id=57ab2bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab2bde",
  null
  
)

export default component.exports